/**
 * Banner Product — Layout Orchestration v1.0
 * Kalite tab, desen seçimi, galeri yönetimi, config switch
 * Mevcut motorlara (ozel-olcu-plus.js, preview.min.js, amorf.js) DOKUNMAZ
 * 2026-04-13
 */
(function() {
  'use strict';

  // ========== GLOBAL REFERANSLAR ==========
  var _raw = window.__ALL_CONFIGS__ || {};
  // Config flat veya nested olabilir — her ikisini de destekle
  var allConfigs = { products: {}, qualityMeta: {} };
  if (_raw.products && typeof _raw.products === 'object') {
    // Nested yapı (config.json direkt inject)
    allConfigs = _raw;
  } else {
    // Flat yapı (tema sync inject — her ürün top-level key)
    var _keys = Object.keys(_raw);
    for (var _ki = 0; _ki < _keys.length; _ki++) {
      var _k = _keys[_ki];
      var _v = _raw[_k];
      if (_k === 'qualityMeta') { allConfigs.qualityMeta = _v; }
      else if (_v && typeof _v === 'object' && (_v.massimoApi || _v.shopifyHandles || _v.m2Price !== undefined)) {
        allConfigs.products[_k] = _v;
      }
    }
  }
  var currentConfig = window.__OZEL_OLCU_CONFIG__;
  var currentProductKey = null;
  var currentQualityKey = null;
  var qualityGroups = {};
  var qualityMeta = allConfigs.qualityMeta || {};

  // ========== DOM REFERANSLARI ==========
  var elQualityTabs = document.getElementById('bp-quality-tabs');
  var elPatterns = document.getElementById('bp-patterns');
  var elTitle = document.getElementById('bp-title');
  var elPatCode = document.getElementById('bp-pat-code');
  var elMainImage = document.getElementById('bp-product-img');
  var elThumbs = document.getElementById('bp-thumbs');
  var elDelivery = document.getElementById('bp-delivery');
  var elRelated = document.getElementById('bp-related');
  var elLiveBadge = document.getElementById('bp-live-badge');
  var elZoomBtn = document.getElementById('bp-zoom-trigger');

  // ========== INIT ==========
  function init() {
    if (!allConfigs || !allConfigs.products) {
      console.warn('[BannerProduct] __ALL_CONFIGS__ bulunamadı veya boş');
      return;
    }

    // Mevcut ürünün config key'ini bul
    currentProductKey = findCurrentProductKey();
    if (!currentProductKey) {
      console.warn('[BannerProduct] Mevcut ürün config\'de bulunamadı');
      return;
    }

    // Kaliteleri grupla
    buildQualityGroups();

    // Mevcut ürünün kalitesini bul
    var product = allConfigs.products[currentProductKey];
    currentQualityKey = normalizeQualityKey(product.qualityCode || '');

    // UI oluştur
    renderQualityTabs();
    renderPatterns(currentQualityKey);
    highlightCurrentPattern();
    renderDeliveryTimeline();
    renderRelated(currentQualityKey);
    initGalleryThumbs();
    initZoom();

    loadComplementary();

    // Kalite/desen değişiminde "Tasarlanıyor..." overlay (mobilde donmuş hissi önler)
    installQualityLoader();

    // Mobilde galeri aç/kapa toggle + parmakla swipe (yer kazanma + şık UX)
    installGalleryCollapse();
    installGallerySwipe();

    
    
    // bp-amorf-hero kaldirildi — fiyat slotu (bp-price-slot) aldi yerini

    // Amorf kota kontrolü
    (function checkAmorfKota() {
      var OFFLINE_MSG = 'Üretim kapasitemiz dolmuştur, gün içerisinde uygunluk durumuna göre sistem otomatik olarak tekrar açılacaktır.';
      function showKapali(msg) {
        var card = document.getElementById('bp-amorf-hero');
        var kotaEl = document.getElementById('bp-amorf-kota');
        var kotaMsg = document.getElementById('bp-amorf-kota-msg');
        if (!card || !kotaEl) return;
        window.__amorfKotaKapali = true;
        card.classList.add('kota-kapali');
        kotaEl.style.display = 'flex';
        if (kotaMsg) kotaMsg.textContent = msg;
      }
      fetch('https://dolcevita-massimo.ngrok.io/api/amorf-kota')
        .then(function(r) {
          if (!r.ok) throw new Error('status ' + r.status);
          return r.json();
        })
        .then(function(k) {
          if (k.kapali) {
            showKapali(k.mesaj || 'Kapasite doldu — ' + (k.acilisSaati || '00:00') + "'da açılacak");
          }
        })
        .catch(function() {
          // Sunucu erişilemiyor → müşteriye kapasite doldu mesajı göster
          showKapali(OFFLINE_MSG);
        });
    })();

    // Teslimat tarihi hesapla — normal: 2-3 iş günü, amorf: +3 iş günü
    var _gunler = ['Pazar','Pazartesi','Salı','Çarşamba','Perşembe','Cuma','Cumartesi'];
    var _aylar = ['Ocak','Şubat','Mart','Nisan','Mayıs','Haziran','Temmuz','Ağustos','Eylül','Ekim','Kasım','Aralık'];
    
    function calcDeliveryDate(extraDays) {
      var _now = new Date();
      var _days = (_now.getHours() < 15 ? 2 : 3) + (extraDays || 0);
      var _dlv = new Date(_now);
      var _added = 0;
      while (_added < _days) {
        _dlv.setDate(_dlv.getDate() + 1);
        if (_dlv.getDay() !== 0 && _dlv.getDay() !== 6) _added++;
      }
      return _dlv.getDate() + ' ' + _aylar[_dlv.getMonth()] + ' ' + _gunler[_dlv.getDay()];
    }
    
    // Mini banner teslimat
    var _dlvEl = document.getElementById('bp-delivery-date');
    if (_dlvEl) _dlvEl.textContent = calcDeliveryDate(0) + ' Teslim';
    
    // Header teslimat
    var _hdrDlv = document.getElementById('bp-header-delivery');
    if (_hdrDlv) _hdrDlv.textContent = calcDeliveryDate(0);
    
    // Shape değiştiğinde teslimat tarihini güncelle
    var _shapeEl = document.getElementById('ozel-olcu-shape');
    if (_shapeEl) {
      _shapeEl.addEventListener('change', function() {
        var isAmorf = (this.value === 'amorf' || this.value === 'daire' || this.value === 'oval');
        var extra = isAmorf ? 3 : 0;
        var dateStr = calcDeliveryDate(extra);
        if (_dlvEl) _dlvEl.textContent = dateStr + ' Teslim';
        if (_hdrDlv) _hdrDlv.textContent = dateStr;
        // Header tag renk değişimi
        var tagEl = document.getElementById('bp-htag-teslimat');
        if (tagEl) tagEl.className = 'bp-htag bp-htag-teslimat' + (isAmorf ? ' amorf-mode' : '');
      });
    }

    // Tema lazy-load opacity fix
    var _bpImg = document.getElementById('bp-product-img');
    if (_bpImg) { _bpImg.style.opacity = '1'; _bpImg.style.removeProperty('opacity'); }
    console.log('[BannerProduct] v1.0 hazır — kalite:', currentQualityKey, 'desen:', currentProductKey);
  }

  // ========== ÜRÜN KEY BULMA ==========
  function findCurrentProductKey() {
    var handle = document.getElementById('banner-product')
      ? document.getElementById('banner-product').getAttribute('data-product-handle')
      : '';

    if (!handle) return null;

    var products = allConfigs.products || {};
    var keys = Object.keys(products);

    for (var i = 0; i < keys.length; i++) {
      var p = products[keys[i]];
      var handles = p.shopifyHandles || {};
      if (handles.biye === handle || handles.bordur === handle || handles.overlok === handle) {
        return keys[i];
      }
      if (p.shopifyHandle === handle) return keys[i];
    }
    return null;
  }

  // ========== KALİTE GRUPLAMA ==========
  function normalizeQualityKey(qualityCode) {
    return (qualityCode || '').toLowerCase().replace(/\s+/g, '-');
  }

  function buildQualityGroups() {
    qualityGroups = {};
    var products = allConfigs.products || {};
    var keys = Object.keys(products);

    for (var i = 0; i < keys.length; i++) {
      var p = products[keys[i]];
      var qk = normalizeQualityKey(p.qualityCode || '');
      if (!qk) continue;

      if (!qualityGroups[qk]) {
        qualityGroups[qk] = {
          label: p.qualityCode || qk,
          products: []
        };
      }
      qualityGroups[qk].products.push({
        key: keys[i],
        patternCode: p.patternCode || '',
        patternImage: p.patternImage || '',
        patternBg: p.patternBg || '',
        handle: (p.shopifyHandles || {}).biye || (p.shopifyHandles || {}).overlok || ''
      });
    }
  }

  // ========== KALİTE TAB RENDER ==========
  function renderQualityTabs() {
    if (!elQualityTabs) return;

    // sortOrder'a göre sırala
    var sortedKeys = Object.keys(qualityGroups).sort(function(a, b) {
      var ma = qualityMeta[a] || {};
      var mb = qualityMeta[b] || {};
      return (ma.sortOrder || 99) - (mb.sortOrder || 99);
    });

    var html = '';
    for (var i = 0; i < sortedKeys.length; i++) {
      var qk = sortedKeys[i];
      var g = qualityGroups[qk];
      var meta = qualityMeta[qk] || {};
      var label = meta.label || g.label || qk;
      var isActive = (qk === currentQualityKey) ? ' active' : '';
      html += '<button class="bp-qtab' + isActive + '" data-quality="' + qk + '">' + escapeHtml(label) + '</button>';
    }
    elQualityTabs.innerHTML = html;

    // Event delegation
    elQualityTabs.addEventListener('click', function(e) {
      var tab = e.target.closest('.bp-qtab');
      if (!tab) return;
      var qk = tab.getAttribute('data-quality');
      if (qk && qk !== currentQualityKey) {
        navigateToQuality(qk);
      }
    });
  }

  // ========== MOBİL THUMB ŞERİDİ AÇ/KAPA ==========
  // Mobilde (<768px) ana görsel + rulerlar HER ZAMAN görünür. Sadece alttaki
  // thumbnail şeridi (bp-gallery__thumbs) varsayılan KAPALI, aşağı ok ile açılır.
  function installGalleryCollapse() {
    if (window.innerWidth >= 768) return; // Sadece mobil
    var thumbs = document.getElementById('bp-thumbs');
    if (!thumbs) return;
    if (document.getElementById('bp-gallery-toggle')) return;

    // CSS enjekte et
    if (!document.getElementById('bp-gallery-collapse-css')) {
      var st = document.createElement('style');
      st.id = 'bp-gallery-collapse-css';
      st.textContent =
        '@media (max-width: 767px) {' +
          '#bp-thumbs { overflow:hidden; transition: max-height 320ms ease, padding 320ms ease; max-height: 200px; }' +
          '#bp-thumbs.bp-thumbs--collapsed { max-height: 0 !important; padding-top: 0 !important; padding-bottom: 0 !important; }' +
          '.bp-gallery-toggle { position: relative; width: 100%; height: 30px; background: #fff; border: none; border-top: 1px solid #eee; border-bottom: 1px solid #eee; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 8px; font-size: 11px; color: #777; font-weight: 500; letter-spacing: 0.3px; padding: 0; }' +
          '.bp-gallery-toggle__chev { width: 11px; height: 11px; transition: transform 260ms ease; display:inline-block; }' +
          '.bp-gallery-toggle.is-open .bp-gallery-toggle__chev { transform: rotate(180deg); }' +
          '.bp-gallery-toggle:active { background: #f9f9f9; }' +
        '}';
      document.head.appendChild(st);
    }

    var btn = document.createElement('button');
    btn.id = 'bp-gallery-toggle';
    btn.className = 'bp-gallery-toggle';
    btn.type = 'button';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', 'bp-thumbs');
    // Inline stil — CSS class'a güvenmeyelim (parent pointer-events/stacking sorunlarına karşı)
    btn.style.cssText = 'position:relative;z-index:20;width:100%;height:32px;background:#fff;border:none;border-top:1px solid #eee;border-bottom:1px solid #eee;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:8px;font-size:11px;color:#555;font-weight:500;letter-spacing:0.3px;padding:0;pointer-events:auto;touch-action:manipulation;-webkit-tap-highlight-color:rgba(232,98,42,0.15);';
    btn.innerHTML =
      '<span class="bp-gallery-toggle__text" style="pointer-events:none;">Diğer Görseller</span>' +
      '<svg class="bp-gallery-toggle__chev" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" style="width:11px;height:11px;transition:transform 260ms ease;display:inline-block;pointer-events:none;"><path d="M2 4.5 L6 8.5 L10 4.5"/></svg>';
    // Toggle butonu thumbs'ın HEMEN ÜSTÜNE koy
    thumbs.parentNode.insertBefore(btn, thumbs);

    // Varsayılan: thumb şeridi kapalı
    thumbs.classList.add('bp-thumbs--collapsed');
    var txt = btn.querySelector('.bp-gallery-toggle__text');
    var chev = btn.querySelector('.bp-gallery-toggle__chev');

    function doToggle(e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      var collapsed = thumbs.classList.toggle('bp-thumbs--collapsed');
      btn.classList.toggle('is-open', !collapsed);
      btn.setAttribute('aria-expanded', String(!collapsed));
      if (txt) txt.textContent = collapsed ? 'Diğer Görseller' : 'Görselleri Gizle';
      if (chev) chev.style.transform = collapsed ? 'rotate(0deg)' : 'rotate(180deg)';
      console.log('[Gallery] Thumbs', collapsed ? 'KAPALI' : 'AÇIK');
    }
    btn.addEventListener('click', doToggle);
    // Mobil: touchend ile de tetikle (bazı overlay'lerin click'i yuttuğu durumlara karşı)
    btn.addEventListener('touchend', function(e) {
      if (e.cancelable) e.preventDefault();
      doToggle(e);
    }, { passive: false });
  }

  // ========== MOBİL GALERİ SWIPE ==========
  // Ana görsel üzerinde parmakla sağa-sola kaydırınca thumbnail'ler arasında gezinir.
  // Thumbnail click handler mevcut onChange akışını tetikler (1. resim amorf giydirme
  // gösterir, 2+ resim orijinal product görselleri).
  function installGallerySwipe() {
    var main = document.getElementById('bp-main-image');
    if (!main || main._swipeInit) return;
    main._swipeInit = true;
    var x0 = null, y0 = null, t0 = 0, active = false;
    main.addEventListener('touchstart', function(e) {
      if (!e.touches || e.touches.length !== 1) return;
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; t0 = Date.now(); active = true;
    }, { passive: true });
    main.addEventListener('touchmove', function(e) {
      if (!active || !e.touches || e.touches.length !== 1) return;
      var dx = e.touches[0].clientX - x0;
      var dy = e.touches[0].clientY - y0;
      // Dikey kaydırma → iptal (sayfa scroll'a bırak)
      if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 10) active = false;
    }, { passive: true });
    main.addEventListener('touchend', function(e) {
      if (!active) return;
      active = false;
      var touch = (e.changedTouches && e.changedTouches[0]) || null;
      if (!touch) return;
      var dx = touch.clientX - x0;
      var dt = Date.now() - t0;
      if (Math.abs(dx) < 40 || dt > 600) return; // çok küçük veya yavaş → swipe sayma
      var thumbs = document.querySelectorAll('#bp-thumbs .bp-thumb');
      if (thumbs.length < 2) return;
      var activeIdx = 0;
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].classList.contains('active')) { activeIdx = i; break; }
      }
      var nextIdx;
      if (dx < 0) { // sola swipe → sonraki
        nextIdx = activeIdx + 1;
        if (nextIdx >= thumbs.length) return;
      } else { // sağa swipe → önceki
        nextIdx = activeIdx - 1;
        if (nextIdx < 0) return;
      }
      thumbs[nextIdx].click();
    }, { passive: true });
  }

  // ========== KALITE LOADER (tasarım overlay) ==========
  // Kullanıcı kalite veya desen tıkladığında "Tasarlanıyor..." overlay'i galeri
  // üzerinde beliriyor; arkada __reinitOzelOlcuConfig + amorf render çalışıyor.
  // Amorf render bitince veya 2s timeout'ta overlay kapanır.
  var _qlHideTimer = null;
  function installQualityLoader() {
    var gallery = document.querySelector('.bp-gallery__main');
    if (!gallery || gallery.querySelector('.bp-quality-loader')) return;
    var overlay = document.createElement('div');
    overlay.className = 'bp-quality-loader';
    overlay.innerHTML =
      '<div class="bp-ql-inner">' +
        '<svg class="bp-ql-svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet">' +
          '<circle class="bp-ql-ring" cx="50" cy="50" r="44" />' +
          '<path class="bp-ql-shape" d="" />' +
        '</svg>' +
        '<div class="bp-ql-text">Tasarlanıyor<span class="bp-ql-dots"><i></i><i></i><i></i></span></div>' +
        '<div class="bp-ql-sub">Halınız hazırlanıyor</div>' +
      '</div>';
    gallery.appendChild(overlay);
    // Amorf render tamamlandığında overlay'i kapat (custom event)
    window.addEventListener('amorf:render:complete', function() {
      hideQualityLoader();
    });
  }

  // Kullanıcının mevcut amorf radii'sinden SVG path üret (dinamik — sipariş şekliyle aynı).
  // Amorf değilse basit dairesel fallback (dikdörtgen/daire için).
  function _buildLoaderShapePath() {
    try {
      if (window.__OzelOlcuAmorf && window.__OzelOlcuAmorf.getShape) {
        var sh = window.__OzelOlcuAmorf.getShape();
        var radii = sh && sh.radii;
        if (radii && radii.length && Array.from(radii).some(function(r){ return r > 0.1; })) {
          var N = radii.length;
          var T = 0.28;
          var cx = 50, cy = 50, rx = 42, ry = 42;
          var pts = [];
          for (var i = 0; i < N; i++) {
            var a = (i / N) * Math.PI * 2 - Math.PI / 2;
            pts.push({ x: cx + Math.cos(a) * radii[i] * rx, y: cy + Math.sin(a) * radii[i] * ry });
          }
          var d = 'M' + pts[0].x.toFixed(1) + ',' + pts[0].y.toFixed(1);
          for (var j = 0; j < N; j++) {
            var p0 = pts[(j-1+N)%N], p1 = pts[j], p2 = pts[(j+1)%N], p3 = pts[(j+2)%N];
            d += ' C' + (p1.x + T*(p2.x-p0.x)).toFixed(1) + ',' + (p1.y + T*(p2.y-p0.y)).toFixed(1) +
                 ' ' + (p2.x - T*(p3.x-p1.x)).toFixed(1) + ',' + (p2.y - T*(p3.y-p1.y)).toFixed(1) +
                 ' ' + p2.x.toFixed(1) + ',' + p2.y.toFixed(1);
          }
          return d + 'Z';
        }
      }
    } catch(e) {}
    return ''; // amorf yok → sadece ring gösterilir
  }

  function showQualityLoader() {
    var ol = document.querySelector('.bp-quality-loader');
    if (!ol) return;
    // Kullanıcının mevcut amorf şekliyle path güncelle (dinamik, karıştırmaz)
    var pathEl = ol.querySelector('.bp-ql-shape');
    var path = _buildLoaderShapePath();
    if (pathEl) {
      pathEl.setAttribute('d', path);
      pathEl.style.display = path ? '' : 'none';
    }
    ol.classList.add('bp-ql-active');
    // Güvenlik: 2.5s içinde render bitmezse kapat
    if (_qlHideTimer) clearTimeout(_qlHideTimer);
    _qlHideTimer = setTimeout(hideQualityLoader, 2500);
  }
  function hideQualityLoader() {
    var ol = document.querySelector('.bp-quality-loader');
    if (!ol) return;
    ol.classList.remove('bp-ql-active');
    if (_qlHideTimer) { clearTimeout(_qlHideTimer); _qlHideTimer = null; }
  }

  // ========== KALİTE DEĞİŞİMİ ==========
  // ========== KALİTE NAVIGATE (URL geçişi + state koruma) ==========
  function navigateToQuality(qk) {
    var group = qualityGroups[qk];
    if (!group || !group.products || group.products.length === 0) return;

    // Mevcut state oku
    var wEl = document.getElementById('ozel-olcu-width');
    var lEl = document.getElementById('ozel-olcu-length');
    var shEl = document.getElementById('ozel-olcu-shape');
    var edgeInput = document.querySelector('input[name="ozel-olcu-edge"]:checked');

    var currentW = wEl ? (wEl.value || '') : '';
    var currentL = lEl ? (lEl.value || '') : '';
    var currentShape = (shEl ? shEl.value : '') || 'dikdortgen';
    var currentEdge = edgeInput ? edgeInput.value : 'biye';

    // Yeni kalitenin ilk ürünü
    var firstProduct = (allConfigs.products || {})[group.products[0].key];
    if (!firstProduct) return;
    var newEdgeTypes = firstProduct.edgeTypes || {};

    // Kenar tipi doğrulama: yeni kalitede yoksa biye'ye düş
    var targetEdge = newEdgeTypes[currentEdge] ? currentEdge : 'biye';

    // Handle al
    var handles = firstProduct.shopifyHandles || {};
    var targetHandle = handles[targetEdge] || handles.biye || handles.overlok || handles.sacak || '';
    if (!targetHandle) return;

    // Amorf radii'yi localStorage'a kaydet
    if (currentShape === 'amorf' && window.__OzelOlcuAmorf && window.__OzelOlcuAmorf.getShape) {
      try {
        var sd = window.__OzelOlcuAmorf.getShape();
        if (sd && sd.radii && sd.radii.length > 0) {
          localStorage.setItem('ozel_olcu_banner_config', JSON.stringify({
            shape: 'amorf', edgeType: targetEdge,
            radii: Array.prototype.slice.call(sd.radii),
            ts: Date.now(), source: 'quality-tab'
          }));
        }
      } catch(_e) {}
    }

    // URL params ile navigate
    var params = [];
    if (currentW && parseInt(currentW) > 0) params.push('_ow=' + encodeURIComponent(currentW));
    if (currentL && parseInt(currentL) > 0) params.push('_oh=' + encodeURIComponent(currentL));
    if (currentShape && currentShape !== 'dikdortgen') params.push('_shape=' + encodeURIComponent(currentShape));
    params.push('_edge=' + encodeURIComponent(currentEdge)); // orijinal edge — restore kodu desteklenip desteklenmediğine karar verir

    var navUrl = '/products/' + targetHandle + (params.length ? '?' + params.join('&') : '');
    console.log('[BannerProduct] Quality navigate:', qk, '->', navUrl);
    window.location.href = navUrl;
  }

  function setQuality(qualityKey) {
    if (!qualityGroups[qualityKey]) return;
    showQualityLoader();
    currentQualityKey = qualityKey;

    // Tab aktifliğini güncelle
    var tabs = elQualityTabs.querySelectorAll('.bp-qtab');
    for (var i = 0; i < tabs.length; i++) {
      if (tabs[i].getAttribute('data-quality') === qualityKey) {
        tabs[i].classList.add('active');
      } else {
        tabs[i].classList.remove('active');
      }
    }

    // Desenleri render et
    renderPatterns(qualityKey);

    // İlk deseni otomatik seç
    var group = qualityGroups[qualityKey];
    if (group.products.length > 0) {
      setPattern(group.products[0].key);
    }

    // Benzer ürünleri güncelle
    renderRelated(qualityKey);
  }

  // ========== DESEN RENDER ==========
  function renderPatterns(qualityKey) {
    if (!elPatterns) return;
    var group = qualityGroups[qualityKey];
    if (!group) { elPatterns.innerHTML = ''; return; }

    var html = '';
    for (var i = 0; i < group.products.length; i++) {
      var p = group.products[i];
      var isActive = (p.key === currentProductKey) ? ' active' : '';

      if (p.patternImage) {
        html += '<div class="bp-pat' + isActive + '" data-key="' + p.key + '" title="' + escapeHtml(p.patternCode) + '">';
        // FIX (desen gorsel iyilestirme): kart boyutlari 52->64/72 olunca
        // width=120 retina'da yumusak kaliyor. width=200'e cikardik: src=
        // aynen CDN URL, sadece width parametresi degisti; aspect ratio
        // (object-fit: cover) ve kaynak bozulmadi — kalite yukseliyor, dusmedi.
        html += '<img src="' + p.patternImage.replace('width=800', 'width=200') + '" alt="' + escapeHtml(p.patternCode) + '" loading="lazy" />';
        html += '</div>';
      } else {
        html += '<div class="bp-pat' + isActive + '" data-key="' + p.key + '" title="' + escapeHtml(p.patternCode) + '"';
        if (p.patternBg) html += ' style="background:' + p.patternBg + '"';
        html += '></div>';
      }
    }
    elPatterns.innerHTML = html;

    // Event delegation ��� pattern tıklama
    elPatterns.onclick = function(e) {
      var pat = e.target.closest('.bp-pat');
      if (!pat) return;
      var key = pat.getAttribute('data-key');
      if (key && key !== currentProductKey) {
        setPattern(key);
      }
    };
  }

  function highlightCurrentPattern() {
    if (!elPatterns) return;
    var pats = elPatterns.querySelectorAll('.bp-pat');
    for (var i = 0; i < pats.length; i++) {
      if (pats[i].getAttribute('data-key') === currentProductKey) {
        pats[i].classList.add('active');
      } else {
        pats[i].classList.remove('active');
      }
    }
    // Desen ismi guncelle (init + degisim)
    var _curCfg = (allConfigs.products || {})[currentProductKey];
    var _dnEl = document.getElementById('bp-desen-name');
    if (_dnEl && _curCfg) _dnEl.textContent = _curCfg.patternCode ? '\u00b7 ' + _curCfg.patternCode : '';
  }

  // ========== DESEN DEĞİŞİMİ ==========
  function setPattern(productKey) {
    var newCfg = (allConfigs.products || {})[productKey];
    if (!newCfg) return;

    showQualityLoader();
    var oldKey = currentProductKey;
    currentProductKey = productKey;

    // Desen karesi aktifliği
    highlightCurrentPattern();

    // Başlık ve desen kodu güncelle
    if (elPatCode) {
      elPatCode.textContent = newCfg.patternCode || '';
    }
    // Desen başlığında isim göster
    var _desenName = document.getElementById('bp-desen-name');
    if (_desenName) _desenName.textContent = newCfg.patternCode ? '· ' + newCfg.patternCode : '';

    // Config switch — ozel-olcu-plus.js'i güncelle
    switchConfig(newCfg);

    // Galeri görsellerini güncelle
    if (oldKey !== productKey) {
      updateGallery(newCfg);
    }

    // Canlı önizleme badge
    if (elLiveBadge) elLiveBadge.style.display = 'none';
  }

  // ========== CONFIG SWITCH ==========
  function switchConfig(newCfg) {
    // ozel-olcu-plus.js'in reinitConfig fonksiyonunu çağır
    if (typeof window.__reinitOzelOlcuConfig === 'function') {
      window.__reinitOzelOlcuConfig(newCfg);
    }

    // Container data attribute'larını güncelle
    var container = document.getElementById('ozel-olcu-plus');
    if (container && newCfg.shopifyHandles) {
      var handle = newCfg.shopifyHandles.biye || newCfg.shopifyHandles.overlok || '';
      container.setAttribute('data-product-handle', handle);
    }

    // Edge type gizleme/gösterme — config'e göre
    var edgeTypes = newCfg.edgeTypes || {};
    var edgeBtns = document.querySelectorAll('[data-edge]');
    for (var i = 0; i < edgeBtns.length; i++) {
      var edge = edgeBtns[i].getAttribute('data-edge');
      edgeBtns[i].style.display = edgeTypes[edge] ? '' : 'none';
    }

    // İlk görünür edge'i seç (eğer seçili olan gizlendiyse)
    var selectedEdgeEl = document.querySelector('.ozel-olcu-plus__radio.active');
    if (selectedEdgeEl && selectedEdgeEl.style.display === 'none') {
      for (var j = 0; j < edgeBtns.length; j++) {
        if (edgeBtns[j].style.display !== 'none') {
          var input = edgeBtns[j].querySelector('input[type="radio"]');
          if (input) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
          break;
        }
      }
    }
    // FIX_SHAPE_RESET kaldırıldı — kalite geçişi artık navigasyon yapar, state URL'de taşınır.
  }

  // ========== GALERİ GÜNCELLEME ==========
  function updateGallery(config) {
    var handle = (config.shopifyHandles || {}).biye
      || (config.shopifyHandles || {}).overlok
      || '';

    if (!handle) return;

    // Loading göster
    if (elMainImage) elMainImage.style.opacity = '0.5';

    fetch('/products/' + handle + '.json')
      .then(function(res) {
        if (!res.ok) throw new Error('Ürün bulunamadı: ' + handle);
        return res.json();
      })
      .then(function(data) {
        var product = data.product;
        if (!product || !product.images || product.images.length === 0) return;

        // Ana görsel güncelle
        var firstImg = product.images[0].src;
        var _newSrc = firstImg.split('?')[0] + '?width=1200';
        // v5.4: Amorf modunda bp-product-img.src'yi OVERWRITE ETME — eski amorf data:url
        // ekranda kalsin ki kullanici flicker (dikdortgen) gormesin. doUpdate
        // data-original-src'den yeni URL'yi okuyup amorf'u render edecek.
        var _isAmorfNow_g = !!(window.__OzelOlcuAmorf && window.__OzelOlcuAmorf.isAmorf && window.__OzelOlcuAmorf.isAmorf());
        if (elMainImage) {
          elMainImage.setAttribute('data-zoom-src', firstImg.split('?')[0] + '?width=2400');
          elMainImage.setAttribute('data-original-src', _newSrc);
          if (!_isAmorfNow_g) {
            elMainImage.src = _newSrc;
          }
          elMainImage.style.opacity = '1';
        }

        // Thumbnail'leri güncelle
        if (elThumbs) {
          var thumbHtml = '';
          for (var i = 0; i < product.images.length; i++) {
            var img = product.images[i];
            var isFirst = (i === 0) ? ' active' : '';
            thumbHtml += '<div class="bp-thumb' + isFirst + '"'
              + ' data-index="' + i + '"'
              + ' data-src="' + img.src.split('?')[0] + '?width=1200"'
              + ' data-zoom="' + img.src.split('?')[0] + '?width=2400"'
              + ' data-original="' + img.src.split('?')[0] + '?width=1200">'
              + '<img src="' + img.src.split('?')[0] + '?width=120" alt="" loading="lazy" width="60" height="60" />'
              + '</div>';
          }
          elThumbs.innerHTML = thumbHtml;
        }

        // Başlık güncelle
        if (elTitle && product.title) {
          elTitle.textContent = product.title;
        }

        // Preview motoru yeniden başlat
        if (window.__ozelOlcuPreview && window.__ozelOlcuPreview.setProductImage) {
          window.__ozelOlcuPreview.setProductImage(firstImg.split('?')[0] + '?width=1200');
        }

        // Amorf aktifse: yeni galeride amorf rendering'i GARANTI ALTINA AL.
        // ESKI BUG (v5.1): Sabit 800ms+500ms gecikme kullanildigi icin yavas yuklenen
        // urun gorseli/kumas durumunda amorf re-render BASARISIZ olup dikdortgen kaliyordu.
        // YENI (v5.2): Polling tabanli — fabric aktif + bp-product-img CDN URL'si ile
        // tam yuklenmis olana kadar bekler, sonra amorfForceUpdate cagirir + 800ms sonra
        // dogrulama yapar (data:url'a donmemisse tekrar dener). 6sn cap, 16 deneme max.
        var _shSel = document.getElementById('ozel-olcu-shape');
        var _isAmorfNow = _shSel && (_shSel.value === 'amorf' || _shSel.value === 'daire' || _shSel.value === 'oval');
        if (_isAmorfNow) {
          if (window.__resetAmorfOriginals) window.__resetAmorfOriginals();

          var _amorfAttempt = 0;
          var _amorfMaxAttempts = 16;
          var _amorfRetry = function() {
            _amorfAttempt++;
            // Kumas aktif degilse otomatik ilk kumasi sec
            if (!document.querySelector('.ozel-olcu-plus__color-btn.active')) {
              var _firstFab = document.querySelector('.ozel-olcu-plus__color-btn');
              if (_firstFab) _firstFab.click();
            }
            var _bpImg = document.getElementById('bp-product-img');
            var _hasFab = !!document.querySelector('.ozel-olcu-plus__color-btn.active');
            // v5.3: Sadece CDN URL'si SET edilmis olmasi yeterli (data: degil).
            // doUpdate kendi icinde Image() ile yuklemeyi yapiyor — naturalWidth/complete
            // beklemek gereksiz (lazy-load yavas Monza gibi durumlarda timeout'a yol aciyor).
            var _bpSrc = _bpImg && (_bpImg.getAttribute('data-original-src') || _bpImg.src) || '';
            var _imgReady = _bpSrc && _bpSrc.indexOf('data:') !== 0 && _bpSrc.length > 10;
            if (_imgReady && _hasFab) {
              if (window.__amorfForceUpdate) {
                console.log('[BannerProduct] Amorf FORCE re-render (attempt ' + _amorfAttempt + ')');
                window.__amorfForceUpdate();
              } else if (window.__amorfGaleriGuncelle) {
                window.__amorfGaleriGuncelle();
              }
              // Dogrulama: 1sn sonra bp-product-img amorf data:url'a donmediyse tekrar dene
              setTimeout(function() {
                var _bp2 = document.getElementById('bp-product-img');
                var _shCheck = document.getElementById('ozel-olcu-shape');
                var _stillAmorf = _shCheck && (_shCheck.value === 'amorf' || _shCheck.value === 'daire' || _shCheck.value === 'oval');
                if (_stillAmorf && _bp2 && (_bp2.src || '').indexOf('data:') !== 0 && _amorfAttempt < _amorfMaxAttempts) {
                  console.warn('[BannerProduct] Amorf data:url uygulanmamis, retry');
                  _amorfRetry();
                }
              }, 1000);
              return;
            }
            if (_amorfAttempt < _amorfMaxAttempts) setTimeout(_amorfRetry, 350);
            else console.warn('[BannerProduct] Amorf re-render polling timeout (img/fabric hazir degil)');
          };
          setTimeout(_amorfRetry, 350);
        }

        // Variant ID güncelle (container data attribute)
        if (product.variants && product.variants.length > 0) {
          var container = document.getElementById('ozel-olcu-plus');
          if (container) {
            container.setAttribute('data-variant-id', product.variants[0].id);
          }
        }

        console.log('[BannerProduct] Galeri güncellendi:', handle, product.images.length, 'görsel');
      })
      .catch(function(err) {
        console.error('[BannerProduct] Galeri güncelleme hatası:', err);
        if (elMainImage) elMainImage.style.opacity = '1';
      });
  }

  // ========== GALERİ THUMBNAIL ==========
  function initGalleryThumbs() {
    if (!elThumbs) return;

    // Event delegation — thumbnail tıklama
    elThumbs.addEventListener('click', function(e) {
      var thumb = e.target.closest('.bp-thumb');
      if (!thumb) return;

      var src = thumb.getAttribute('data-src');
      var zoomSrc = thumb.getAttribute('data-zoom');

      if (!src || !elMainImage) return;

      // Aktif thumbnail güncelle
      var allThumbs = elThumbs.querySelectorAll('.bp-thumb');
      for (var i = 0; i < allThumbs.length; i++) {
        allThumbs[i].classList.remove('active');
      }
      thumb.classList.add('active');

      // Ana görsel güncelle
      var thumbIdx = parseInt(thumb.getAttribute('data-index') || '0');
      // Video player kontrolü
      var mediaType = thumb.getAttribute('data-media-type') || 'image';
      var videoPlayer = document.getElementById('bp-video-player');
      var videoEl = document.getElementById('bp-video-el');
      if (mediaType === 'video' || mediaType === 'external_video') {
        // Video göster
        if (videoPlayer && videoEl) {
          var videoUrl = thumb.getAttribute('data-video-url');
          if (videoUrl) {
            videoEl.src = videoUrl;
            videoPlayer.classList.add('bp-video-active');
            elMainImage.style.display = 'none';
            videoEl.play().catch(function(){});
          }
        }
      } else {
        // Image göster, video gizle
        if (videoPlayer) { videoPlayer.classList.remove('bp-video-active'); if (videoEl) { videoEl.pause(); videoEl.src = ''; } }
        if (elMainImage) elMainImage.style.display = '';
      }

      // Amorf overlay/hotspot sadece 1. resimde gorunsun
      var _amorfOv = document.getElementById('bp-amorf-dim-overlay');
      var _presetBg = document.getElementById('bp-preset-badge');
      var _hsEdge = document.getElementById('bp-hs-edge');
      if (thumbIdx === 0) {
        if (_amorfOv) _amorfOv.style.display = '';
        if (_presetBg) _presetBg.style.display = '';
        if (_hsEdge) _hsEdge.style.display = '';
        document.querySelectorAll('.bp-ruler').forEach(function(r){r.style.display='';});
      } else {
        if (_amorfOv) _amorfOv.style.display = 'none';
        if (_presetBg) _presetBg.style.display = 'none';
        if (_hsEdge) _hsEdge.style.display = 'none';
        document.querySelectorAll('.bp-ruler').forEach(function(r){r.style.display='none';});
      }
      if (thumbIdx === 0 && window.__amorfActive && window._amorfCurrentDataUrl) {
        // Amorf aktif ve 1. görsele dönüyor — amorf giydirmeyi geri yükle
        elMainImage.src = window._amorfCurrentDataUrl;
        elMainImage.setAttribute('data-zoom-src', window._amorfCurrentDataUrl);
        elMainImage.setAttribute('data-original-src', src);
      } else {
        elMainImage.src = src;
        if (zoomSrc) {
          elMainImage.setAttribute('data-zoom-src', zoomSrc);
        }
        elMainImage.setAttribute('data-original-src', src);
      }
    });
  }

  // ========== ZOOM ==========
  function initZoom() {
    if (!elZoomBtn || !elMainImage) return;

    elZoomBtn.addEventListener('click', function() {
      // Giydirmeli preview (data:url) varsa onu goster, yoksa orijinal zoom
      var zoomSrc = (elMainImage.src && elMainImage.src.indexOf('data:') === 0)
        ? elMainImage.src
        : (elMainImage.getAttribute('data-zoom-src') || elMainImage.src);
      openLightbox(zoomSrc);
    });

    // Ana görsele tıklayınca da zoom
    elMainImage.addEventListener('click', function() {
      var zoomSrc = (elMainImage.src && elMainImage.src.indexOf('data:') === 0)
        ? elMainImage.src
        : (elMainImage.getAttribute('data-zoom-src') || elMainImage.src);
      openLightbox(zoomSrc);
    });
    elMainImage.style.cursor = 'zoom-in';
  }

  // ========== CETVEL / RULER ==========
  function createRulers() {
    var gallery = document.querySelector('.bp-gallery__main');
    if (!gallery || document.getElementById('bp-ruler-h')) return;

    // Ok tipleri (CSS triangle)
    var _rArrL = '<span style="flex-shrink:0;width:0;height:0;border-top:5px solid transparent;border-bottom:5px solid transparent;border-right:7px solid #333;"></span>';
    var _rArrR = '<span style="flex-shrink:0;width:0;height:0;border-top:5px solid transparent;border-bottom:5px solid transparent;border-left:7px solid #333;"></span>';
    var _rArrU = '<span style="flex-shrink:0;width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-bottom:7px solid #333;"></span>';
    var _rArrD = '<span style="flex-shrink:0;width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top:7px solid #333;"></span>';

    // Yatay cetvel (en) — ALTTA, gallery genişliğinin %85'i, merkezli (amorf dim-h ile aynı hizada)
    var hRuler = document.createElement('div');
    hRuler.id = 'bp-ruler-h';
    hRuler.className = 'bp-ruler bp-ruler--h';
    hRuler.style.cssText = 'position:absolute;bottom:4px;left:50%;transform:translateX(-50%);width:85%;height:20px;display:flex;align-items:center;gap:3px;z-index:15;pointer-events:none;';
    hRuler.innerHTML =
      _rArrL +
      '<span style="flex:1;border-top:1.4px solid #333;"></span>' +
      '<span class="bp-ruler__label" id="bp-ruler-h-label" style="padding:2px 6px;font-size:11px;font-weight:600;color:#333;background:rgba(255,255,255,0.95);border-radius:3px;white-space:nowrap;pointer-events:auto;">100 cm</span>' +
      '<span style="flex:1;border-top:1.4px solid #333;"></span>' +
      _rArrR;

    // Dikey cetvel (boy) — SOLDA, gallery yüksek'inin %85'i, merkezli (amorf dim-v ile aynı hizada)
    var vRuler = document.createElement('div');
    vRuler.id = 'bp-ruler-v';
    vRuler.className = 'bp-ruler bp-ruler--v';
    vRuler.style.cssText = 'position:absolute;left:4px;top:50%;transform:translateY(-50%);height:85%;width:20px;display:flex;flex-direction:column;align-items:center;gap:3px;z-index:15;pointer-events:none;';
    vRuler.innerHTML =
      _rArrU +
      '<span style="flex:1;border-left:1.4px solid #333;"></span>' +
      '<span class="bp-ruler__label" id="bp-ruler-v-label" style="padding:4px 3px;font-size:11px;font-weight:600;color:#333;background:rgba(255,255,255,0.95);border-radius:3px;writing-mode:vertical-lr;transform:rotate(180deg);white-space:nowrap;pointer-events:auto;">200 cm</span>' +
      '<span style="flex:1;border-left:1.4px solid #333;"></span>' +
      _rArrD;

    gallery.style.paddingBottom = '28px';
    gallery.style.paddingLeft = '28px';

    gallery.appendChild(hRuler);
    gallery.appendChild(vRuler);

    // Ölçü değiştiğinde güncelle
    var wInput = document.getElementById('ozel-olcu-width');
    var hInput = document.getElementById('ozel-olcu-length');
    function updateLabels() {
      var hLabel = document.getElementById('bp-ruler-h-label');
      var vLabel = document.getElementById('bp-ruler-v-label');
      if (hLabel && wInput) hLabel.textContent = (wInput.value || '100') + ' cm';
      if (vLabel && hInput) vLabel.textContent = (hInput.value || '200') + ' cm';
    }
    if (wInput) wInput.addEventListener('input', updateLabels);
    if (hInput) hInput.addEventListener('input', updateLabels);
    updateLabels();
  }

  // Sayfa yüklendiğinde cetvelleri oluştur
  setTimeout(createRulers, 500);

  function openLightbox(src) {
    var existing = document.getElementById('bp-lightbox');
    if (existing) existing.remove();

    var isDataUrl = src && src.indexOf('data:') === 0;

    var overlay = document.createElement('div');
    overlay.id = 'bp-lightbox';
    overlay.style.cssText = 'position:fixed;inset:0;z-index:9999;background:rgba(245,245,245,0.97);display:flex;align-items:center;justify-content:center;overflow:auto;';

    var imgWrap = document.createElement('div');
    imgWrap.style.cssText = 'display:flex;align-items:center;justify-content:center;min-height:100%;padding:20px;';

    var img = document.createElement('img');
    img.src = src;
    img.alt = 'Zoom';
    img.style.cssText = 'max-width:90vw;max-height:90vh;object-fit:contain;cursor:zoom-in;transition:transform 0.25s ease;background:#fff;border-radius:8px;box-shadow:0 4px 30px rgba(0,0,0,0.15);';

    var closeBtn = document.createElement('button');
    closeBtn.style.cssText = 'position:fixed;top:16px;right:16px;width:40px;height:40px;background:rgba(0,0,0,0.08);border:none;border-radius:50%;color:#333;font-size:22px;cursor:pointer;display:flex;align-items:center;justify-content:center;z-index:10;';
    closeBtn.innerHTML = '\u00D7';
    closeBtn.addEventListener('click', function(e) { e.stopPropagation(); close(); });

    imgWrap.appendChild(img);
    overlay.appendChild(imgWrap);
    overlay.appendChild(closeBtn);
    document.body.appendChild(overlay);

    function close() { overlay.remove(); }
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay || e.target === imgWrap) close();
    });
    document.addEventListener('keydown', function handler(e) {
      if (e.key === 'Escape') { close(); document.removeEventListener('keydown', handler); }
    });

    // Zoom + Pan sistemi
    var zoomLevels = [1, 1.5, 2.5];
    var zoomIdx = 0;
    var panX = 0, panY = 0;
    var isDragging = false, dragStartX = 0, dragStartY = 0, startPanX = 0, startPanY = 0;

    function applyTransform() {
      var z = zoomLevels[zoomIdx];
      if (z > 1) {
        img.style.transform = 'scale(' + z + ') translate(' + panX + 'px,' + panY + 'px)';
        img.style.cursor = isDragging ? 'grabbing' : 'grab';
        img.style.maxWidth = 'none';
        img.style.maxHeight = 'none';
        imgWrap.style.overflow = 'visible';
      } else {
        img.style.transform = '';
        img.style.cursor = 'zoom-in';
        img.style.maxWidth = '90vw';
        img.style.maxHeight = '90vh';
        panX = 0; panY = 0;
      }
    }

    // Zoom badge
    var zoomBadge = document.createElement('div');
    zoomBadge.style.cssText = 'position:fixed;bottom:20px;left:50%;transform:translateX(-50%);background:rgba(0,0,0,0.6);color:#fff;padding:6px 16px;border-radius:20px;font-size:13px;font-weight:600;z-index:10;pointer-events:none;transition:opacity 0.3s;opacity:0;';
    overlay.appendChild(zoomBadge);
    function showZoomBadge(text) {
      zoomBadge.textContent = text;
      zoomBadge.style.opacity = '1';
      clearTimeout(zoomBadge._t);
      zoomBadge._t = setTimeout(function() { zoomBadge.style.opacity = '0'; }, 1500);
    }

    // Click-to-zoom + double-click reset
    var lastClickTime = 0;
    var clickTimer = null;
    img.addEventListener('click', function(e) {
      e.stopPropagation();
      if (isDragging) return;
      var now = Date.now();
      if (now - lastClickTime < 100) return;
      // Double-click: aninda 1x'e don
      if (clickTimer) { clearTimeout(clickTimer); clickTimer = null; zoomIdx = 0; panX = 0; panY = 0; applyTransform(); showZoomBadge('1x'); return; }
      clickTimer = setTimeout(function() {
        clickTimer = null;
        zoomIdx = (zoomIdx + 1) % zoomLevels.length;
        if (zoomIdx === 0) { panX = 0; panY = 0; }
        var z = zoomLevels[zoomIdx];
        showZoomBadge(z === 1 ? '1x' : z + 'x \u2014 s\u00fcr\u00fckle');
        applyTransform();
      }, 250);
    });

    // Mouse drag-to-pan (5px+ hareket gerekli, yoksa click sayilir)
    var mouseDownActive = false;
    var didRealDrag = false;
    img.addEventListener('mousedown', function(e) {
      if (zoomLevels[zoomIdx] <= 1) return;
      e.preventDefault();
      mouseDownActive = true;
      didRealDrag = false;
      dragStartX = e.clientX; dragStartY = e.clientY;
      startPanX = panX; startPanY = panY;
    });
    window.addEventListener('mousemove', function(e) {
      if (!mouseDownActive) return;
      var dx = e.clientX - dragStartX, dy = e.clientY - dragStartY;
      if (!didRealDrag && Math.abs(dx) + Math.abs(dy) < 5) return;
      didRealDrag = true;
      isDragging = true;
      var z = zoomLevels[zoomIdx];
      panX = startPanX + dx / z;
      panY = startPanY + dy / z;
      img.style.cursor = 'grabbing';
      applyTransform();
    });
    window.addEventListener('mouseup', function() {
      if (!mouseDownActive) return;
      mouseDownActive = false;
      if (didRealDrag) { lastClickTime = Date.now(); }
      isDragging = false;
      didRealDrag = false;
      applyTransform();
    });

    // Mobil: tek parmak pan + cift parmak pinch-zoom
    var scale = 1;
    var lastDist = 0;
    var touchStartX = 0, touchStartY = 0, touchStartPanX = 0, touchStartPanY = 0;
    img.addEventListener('touchstart', function(e) {
      if (e.touches.length === 2) {
        lastDist = Math.hypot(e.touches[0].pageX - e.touches[1].pageX, e.touches[0].pageY - e.touches[1].pageY);
      } else if (e.touches.length === 1 && zoomLevels[zoomIdx] > 1) {
        touchStartX = e.touches[0].clientX; touchStartY = e.touches[0].clientY;
        touchStartPanX = panX; touchStartPanY = panY;
      }
    }, { passive: true });
    img.addEventListener('touchmove', function(e) {
      if (e.touches.length === 2) {
        var dist = Math.hypot(e.touches[0].pageX - e.touches[1].pageX, e.touches[0].pageY - e.touches[1].pageY);
        if (lastDist > 0) {
          scale = Math.max(0.5, Math.min(4, scale * (dist / lastDist)));
          img.style.transform = 'scale(' + scale + ')';
        }
        lastDist = dist;
      } else if (e.touches.length === 1 && zoomLevels[zoomIdx] > 1) {
        e.preventDefault();
        var z = zoomLevels[zoomIdx];
        panX = touchStartPanX + (e.touches[0].clientX - touchStartX) / z;
        panY = touchStartPanY + (e.touches[0].clientY - touchStartY) / z;
        applyTransform();
      }
    }, { passive: false });
  }

  // ========== TESLİMAT TİMELINE ==========
  function renderDeliveryTimeline() {
    if (!elDelivery) return;

    var now = new Date();
    var hour = now.getHours();

    // Sipariş tarihi
    var orderDate = new Date(now);

    // Kargo tarihi: bugün 15:00'dan önce → bugün, sonra → yarın
    var shipDate = new Date(now);
    if (hour >= 15) shipDate.setDate(shipDate.getDate() + 1);
    // Pazar atla
    if (shipDate.getDay() === 0) shipDate.setDate(shipDate.getDate() + 1);

    // Teslimat tarihi: kargo + 2 gün
    var delivDate = new Date(shipDate);
    delivDate.setDate(delivDate.getDate() + 2);
    if (delivDate.getDay() === 0) delivDate.setDate(delivDate.getDate() + 1);

    var gunler = ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt'];

    function fmt(d) {
      return ('0' + d.getDate()).slice(-2) + '.' + ('0' + (d.getMonth() + 1)).slice(-2);
    }

    elDelivery.innerHTML =
      '<div class="bp-dlv-step"><div class="bp-dlv-dot done">1</div><span>Sipariş</span><small>' + fmt(orderDate) + ' ' + gunler[orderDate.getDay()] + '</small></div>' +
      '<div class="bp-dlv-step"><div class="bp-dlv-dot">2</div><span>Kargo</span><small>' + fmt(shipDate) + ' ' + gunler[shipDate.getDay()] + '</small></div>' +
      '<div class="bp-dlv-step"><div class="bp-dlv-dot">3</div><span>Teslim</span><small>' + fmt(delivDate) + ' ' + gunler[delivDate.getDay()] + '</small></div>';
  }

  // ========== BENZER ÜRÜNLER ==========
  function renderRelated(qualityKey) {
    if (!elRelated) return;
    var group = qualityGroups[qualityKey];
    if (!group || group.products.length <= 1) {
      elRelated.innerHTML = '';
      return;
    }

    var html = '<div class="bp-related-title">Aynı koleksiyon</div><div class="bp-related-list">';
    for (var i = 0; i < group.products.length; i++) {
      var p = group.products[i];
      if (p.key === currentProductKey) continue;

      var cfg = (allConfigs.products || {})[p.key] || {};
      var price = cfg.m2Price ? (cfg.m2Price + ' TL/m²') : '';

      html += '<div class="bp-rel-card" data-key="' + p.key + '">';
      html += '<div class="bp-rel-img">';
      if (p.patternImage) {
        html += '<img src="' + p.patternImage.replace('width=800', 'width=200') + '" alt="' + escapeHtml(p.patternCode) + '" loading="lazy" />';
      }
      html += '</div>';
      html += '<div class="bp-rel-name">' + escapeHtml(p.patternCode) + '</div>';
      if (price) html += '<div class="bp-rel-price">' + price + '</div>';
      html += '</div>';
    }
    html += '</div>';
    elRelated.innerHTML = html;

    // Tıklama — desen değiştir
    elRelated.onclick = function(e) {
      var card = e.target.closest('.bp-rel-card');
      if (!card) return;
      var key = card.getAttribute('data-key');
      if (key) setPattern(key);
    };
  }



  // ========== COMPLEMENTARY PRODUCTS (Diğer Şekil Seçenekleri) ==========
  function loadComplementary() {
    var el = document.getElementById('bp-complementary');
    if (!el) return;

    var productId = document.getElementById('banner-product')
      ? document.getElementById('banner-product').getAttribute('data-product-id')
      : '';
    if (!productId) return;

    fetch('/recommendations/products.json?product_id=' + productId + '&intent=complementary&limit=6')
      .then(function(res) { return res.ok ? res.json() : null; })
      .then(function(data) {
        if (!data || !data.products || data.products.length === 0) {
          el.style.display = 'none';
          return;
        }

        var html = '<div class="bp-related-title">Diğer Şekil Seçenekleri</div>';
        html += '<div class="bp-related-list">';
        for (var i = 0; i < data.products.length; i++) {
          var p = data.products[i];
          var img = (p.featured_image) ? p.featured_image.replace(/\.jpg|.png|.webp/, function(m) { return m; }).split('?')[0] + '?width=200' : '';
          var price = p.price ? (p.price / 100).toLocaleString('tr-TR') + ' TL' : '';

          html += '<a href="' + p.url + '" class="bp-rel-card" style="text-decoration:none;color:inherit;">';
          html += '<div class="bp-rel-img">';
          if (img) html += '<img src="' + img + '" alt="' + escapeHtml(p.title) + '" loading="lazy" />';
          html += '</div>';
          html += '<div class="bp-rel-name">' + escapeHtml(p.title.replace(/Dolce Vita Hal[ıi]s*/i, '')) + '</div>';
          if (price) html += '<div class="bp-rel-price">' + price + '</div>';
          html += '</a>';
        }
        html += '</div>';
        el.innerHTML = html;
      })
      .catch(function(err) {
        console.warn('[BannerProduct] Complementary yüklenemedi:', err);
        el.style.display = 'none';
      });
  }

  // ========== KUMAŞ SEÇİMİNDE CANLI ÖNİZLEME BADGE ==========
  function watchFabricSelection() {
    var colorOptions = document.getElementById('ozel-olcu-color-options');
    if (!colorOptions) return;

    var observer = new MutationObserver(function() {
      // Kumaş seçilince canlı önizleme badge göster
      var selected = colorOptions.querySelector('.selected, .active');
      if (selected && elLiveBadge) {
        elLiveBadge.style.display = '';
      }
    });
    observer.observe(colorOptions, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  // ========== YARDIMCI ==========
  function escapeHtml(str) {
    if (!str) return '';
    return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // ========== BAŞLAT ==========
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      // Motorların yüklenmesini bekle
      setTimeout(init, 300);
      setTimeout(watchFabricSelection, 1500);
    setTimeout(reorderTrustSection, 800);
    });
  } else {
    setTimeout(init, 300);
    setTimeout(watchFabricSelection, 1500);
    setTimeout(reorderTrustSection, 800);
  }

  // Sıralama: Timeline → Paylaş → Güvenli Ödeme

  // -- FIYAT SLOTU + SLIDER -- variant:change ile guncelle + kaydirma cubugu
  (function() {
    var slot = document.getElementById('bp-price-slot');

    // === FiYAT FORMAT ===
    function fmtTL(n) {
      return new Intl.NumberFormat('tr-TR', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(n);
    }

    // === FIYAT SLOT RENDER ===
    function renderPriceSlot(price, comparePrice, variantTitle) {
      if (!slot) return;
      var hasDiscount = comparePrice > price;
      var pct = hasDiscount ? Math.round((1 - price / comparePrice) * 100) : 0;
      var savings = hasDiscount ? fmtTL(comparePrice - price) : 0;
      var inst6 = fmtTL(price / 6);
      var pesin = fmtTL(price);
      var sizeHint = (variantTitle && variantTitle !== 'Default Title') ? variantTitle + ' i\u00E7in ' : '';
      var h = '';
      if (hasDiscount) h += '<div class="bps-discount-badge">%' + pct + ' \u0130ND\u0130R\u0130M &bull; ' + savings + ' TL TASARRUF</div>';
      h += '<div class="bps-taksit-row">&#128179; ' + sizeHint + '6 TAKS\u0130T, pe\u015fin fiyat\u0131na ' + pesin + ' TL</div>';
      h += '<div class="bps-monthly-row"><span class="bps-monthly-amount">' + inst6 + ' TL</span><span class="bps-monthly-term">&nbsp;x 6 AY</span></div>';
      slot.innerHTML = h;
    }

    document.addEventListener('variant:change', function(e) {
      if (!e.detail || !e.detail.variant) return;
      var v = e.detail.variant;
      var price   = (v.price || 0) / 100;
      var compare = (v.compare_at_price || v.price || 0) / 100;
      var title   = v.title || v.name || '';
      if (price > 0) renderPriceSlot(price, compare, title);
    });

    // === SLIDER SISTEMI ===
    function initSliders() {
      var wNum   = document.getElementById('ozel-olcu-width');
      var lNum   = document.getElementById('ozel-olcu-length');
      var wRange = document.getElementById('bp-range-width');
      var lRange = document.getElementById('bp-range-length');

      if (!wNum || !lNum || !wRange || !lRange) return;

      // Track rengi guncelleyici
      function updateTrack(range) {
        var min = parseFloat(range.min) || 50;
        var max = parseFloat(range.max) || 200;
        var val = parseFloat(range.value) || min;
        var pct = ((val - min) / (max - min) * 100).toFixed(1) + '%';
        range.style.setProperty('--pct', pct);
      }

      // Sayisal input -> slider sync
      function syncNumToRange(numEl, rangeEl) {
        var v = parseInt(numEl.value);
        if (!isNaN(v) && v >= parseInt(rangeEl.min) && v <= parseInt(rangeEl.max)) {
          rangeEl.value = v;
          updateTrack(rangeEl);
        }
      }

      // Slider -> sayisal input sync
      function syncRangeToNum(rangeEl, numEl) {
        numEl.value = rangeEl.value;
        numEl.classList.remove('bp-showing-default');
        updateTrack(rangeEl);
        numEl.dispatchEvent(new Event('input', { bubbles: true }));
      }

      // EN (width) slider
      wRange.addEventListener('input', function() {
        syncRangeToNum(wRange, wNum);
      });

      // BOY (length) slider
      lRange.addEventListener('input', function() {
        syncRangeToNum(lRange, lNum);
      });

      // Sayisal input -> slider (FIX 2026-05-11: isTrusted — programatik event'leri sayma)
      wNum.addEventListener('input', function(e) {
        if (e.isTrusted) wNum.classList.remove('bp-showing-default');
        syncNumToRange(wNum, wRange);
      });
      lNum.addEventListener('input', function(e) {
        if (e.isTrusted) lNum.classList.remove('bp-showing-default');
        syncNumToRange(lNum, lRange);
      });

      // Focus: silik default ise VALUE SİL + class kaldir (FIX 2026-05-11)
      [wNum, lNum].forEach(function(el) {
        el.addEventListener('focus', function() {
          if (this.classList.contains('bp-showing-default')) {
            this.value = '';
            this.classList.remove('bp-showing-default');
          }
        });
      });

      // Track renklerini baslat
      updateTrack(wRange);
      updateTrack(lRange);

      // ozel-olcu-plus.js kendi snap'ini yapinca: snapped width'i range'e yansi
      // (ozel-olcu-width-info guncellenince slot'un snap yansimasi icin)
      var wInfoEl = document.getElementById('ozel-olcu-width-info');
      if (wInfoEl) {
        var wInfoObs = new MutationObserver(function() {
          var v = parseInt(wNum.value);
          if (!isNaN(v) && v >= 50 && v <= 200) { wRange.value = v; updateTrack(wRange); }
        });
        wInfoObs.observe(wInfoEl, { childList: true, subtree: true, characterData: true });
      }
    }

    // === DEFAULT 80x100 TETIKLEME ===
    function triggerDefaultCalc() {
      var wEl = document.getElementById('ozel-olcu-width');
      var lEl = document.getElementById('ozel-olcu-length');
      var wRange = document.getElementById('bp-range-width');
      var lRange = document.getElementById('bp-range-length');
      if (!wEl || !lEl) return;
      if (wEl.value && !wEl.classList.contains('bp-showing-default')) return;
      if (lEl.value && !lEl.classList.contains('bp-showing-default')) return;

      // 80 cm en default
      wEl.value = '80';
      wEl.classList.add('bp-showing-default');
      if (wRange) { wRange.value = '80'; wRange.style.setProperty('--pct', '15%'); }
      wEl.dispatchEvent(new Event('input', { bubbles: true }));

      setTimeout(function() {
        if (lEl.value && !lEl.classList.contains('bp-showing-default')) return;
        lEl.value = '100';
        lEl.classList.add('bp-showing-default');
        if (lRange) { lRange.value = '100'; lRange.style.setProperty('--pct', '9.1%'); }
        lEl.dispatchEvent(new Event('input', { bubbles: true }));

        // FIX 2026-05-11: Kullanıcı focus alınca silik default'u temizle — sayım handler aşağıda
      }, 350);
    }

    // FIX 2026-05-11: Default silik gösterilen "80"/"100" input'u tıklayınca/focus alınca temizle
    function setupDefaultClearOnFocus() {
      var wEl = document.getElementById('ozel-olcu-width');
      var lEl = document.getElementById('ozel-olcu-length');
      function setupOne(el) {
        if (!el || el._defaultClearBound) return;
        el._defaultClearBound = true;
        el.addEventListener('focus', function() {
          if (el.classList.contains('bp-showing-default')) {
            el.value = '';
            el.classList.remove('bp-showing-default');
            el.dataset.userEdited = '1';
            // input event tetikleme — yoksa banner fiyat NaN gösterir; sadece value boş kaldı
          }
        });
        // İlk yazma anında da default class kaldır — SADECE KULLANICI EVENT'LERİ (isTrusted)
        // Programatik dispatchEvent (triggerDefaultCalc'tan) tetiklenmesini engelle
        el.addEventListener('input', function(e) {
          if (!e.isTrusted) return;  // Programatik event ise atla
          if (el.value && el.classList.contains('bp-showing-default')) {
            el.classList.remove('bp-showing-default');
            el.dataset.userEdited = '1';
          }
        });
      }
      setupOne(wEl);
      setupOne(lEl);
    }

    // Init
    setTimeout(function() { initSliders(); }, 200);
    // FIX 2026-05-11: Focus-clear handler — kullanıcı silik default'u tıklayınca temizler
    setTimeout(function() { setupDefaultClearOnFocus(); }, 250);
    setTimeout(triggerDefaultCalc, 1000);
  })();



    function reorderTrustSection() {
    var _trust = document.querySelector('.bp-trust');
    var _share = document.querySelector('.bp-share');
    var _timeline = _trust ? _trust.querySelector('.bp-delivery-timeline') : null;
    var _parent = _share ? _share.parentNode : null;
    if (_trust && _share && _timeline && _parent) {
      _parent.insertBefore(_timeline, _share);
      console.log('[BannerProduct] DOM reorder: Timeline → Share → Trust');
    }

    // FIX 2026-05-12: bp-header-tags (6 Taksit, Ücretsiz Kargo, 15 Mayıs, Robot Süpürge)
    // Timeline'ın hemen altına taşı (Sipariş-Kargo-Teslim altında dursun).
    // Sıralama: Timeline → Tags → Share → Trust
    var _tags = document.querySelector('.bp-header-tags');
    if (_tags && _timeline && _timeline.parentNode) {
      _timeline.parentNode.insertBefore(_tags, _timeline.nextSibling);
      console.log('[BannerProduct] DOM reorder: header-tags → Timeline sonrasına taşındı');
    }
  }

})();
